import { useAppTranslation } from '@/hooks/useAppTranslation';
import { useSafeAreaPadding } from '@/hooks/useSafeAreaPadding';
import type { ReactElement } from 'react';
import { SizableText, YStack } from 'tamagui';

export const OfflineModeBanner = (): ReactElement => {
  const { t } = useAppTranslation();
  const { topPadding } = useSafeAreaPadding();

  return (
    <YStack
      backgroundColor="$brand"
      paddingHorizontal="$4"
      paddingTop={topPadding}
      paddingBottom="$2"
    >
      <SizableText size="$1" color="$background" textAlign="center">
        {t('offlineMode.banner')}
      </SizableText>
    </YStack>
  );
};
